import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgError = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-298.67 -348.44 2133.33 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M382.5 1305.0Q559 1408 768.0 1408.0Q977 1408 1153.5 1305.0Q1330 1202 1433.0 1025.5Q1536 849 1536.0 640.0Q1536 431 1433.0 254.5Q1330 78 1153.5 -25.0Q977 -128 768.0 -128.0Q559 -128 382.5 -25.0Q206 78 103.0 254.5Q0 431 0.0 640.0Q0 849 103.0 1025.5Q206 1202 382.5 1305.0ZM896 161V351Q896 365 887.0 374.5Q878 384 865 384H673Q660 384 650.0 374.0Q640 364 640 351V161Q640 148 650.0 138.0Q660 128 673 128H865Q878 128 887.0 137.5Q896 147 896 161ZM894 505 912 1126Q912 1138 902 1144Q892 1152 878 1152H658Q644 1152 634 1144Q624 1138 624 1126L641 505Q641 495 651.0 487.5Q661 480 675 480H860Q874 480 883.5 487.5Q893 495 894 505Z"
	})
});
export default SvgError;
